// Module
var code = `<form name="cardAddressForm" id="cardAddressForm" #cardAddressForm="ngForm">
    <div id="addressDetailsLabel"
         class="HOA-flextable-component__subheader u-pT3 u-mB7 HOA-flex-component HOA-flex-component-row-wrap">
        <div class="HOA-flextable-component__subheader HOA-ccpayment-address-detail" style="flex-basis: content">
            Card Billing Address
        </div>
        <div *ngIf="selectProperty" class="Field Field--xs u-cf HOA-flex-component HOA-ccpayment-same-as HOA-flex-component__vertical-center">
            <label class="Field-label u-mL2" for="select-menu-size-xs">Same as </label>
            <div class="Select u-mL2" style="overflow: visible;">
                <select id="select-menu-size-xs"
                        name="select-menu-size-xs"
                        [(ngModel)]="selectedPropertyIndex"
                        (change)="propertyDropdownChange()">
                    <option value="-1">Choose Property</option>
                    <option *ngFor="let property of properties; index as i"
                            [ngValue]="i">{{property.nickname}}</option>
                </select>
                <span class="Select-arrow"></span>
            </div>
        </div>
        <div *ngIf="!selectProperty" class="Field Field--xs u-cf HOA-flex-component HOA-ccpayment-same-as HOA-flex-component__vertical-center">
            <div class="u-pL3">
                <div tid="sameAsProperty" class="checkbox Field Field--xs Field-label u-cf" style="display: inline-block;">
                    <input type="checkbox" [(ngModel)]="prefillAddressForm" name="prefillAddressForm" (change)="toggleSameAsProperty()"/>
                </div>
                <span class="HOA-font-light" style="margin-left: 10px" tid="sameAsProperty-label">Same as Property</span>
            </div>
        </div>
    </div>
    <div>
        <div class="HOA-card-flex-container HOA-card-flex--wrap">
            <div class="Field HOA-card-flex-offset-child-left">
                <label for="address1" class="Field-label" tid="address1Label">
                    Address Line 1
                    <span class="asterisk-required">&nbsp;*</span>
                    <div style="float: right;"></div>
                </label>
                <input type="text"
                       name="address1"
                       id="address1"
                       required
                       class="Input"
                       tid="address1Input"
                       maxlength="100"
                       #address1="ngModel"
                       [ngClass]="{'HOA-form-input-field-error': formErrors.address1 || formErrors.noPoBox1}"
                       (blur)="onBlur(address1)"
                       [(ngModel)]="formValues.address1"
                       [disabled]="!selectProperty && prefillAddressForm">
                <div *ngIf="formErrors.address1">
                    <span class="HOA-form-field-error" tid="address1-field-error">Please enter property address.</span>
                </div>
                <div *ngIf="formErrors.noPoBox1">
                    <span class="HOA-form-field-error" tid="address1-field-error">PO Box addresses are not allowed.</span>
                </div>
            </div>
            <div class="Field HOA-card-flex-offset-child-right HOA-card-has-details">
                <label for="unitNumber" class="Field-label" tid="unitNumberLabel">
                    Unit #
                    <div style="float: right;"></div>
                </label>
                <input type="text"
                       name="unitNumber"
                       id="unitNumber"
                       class="Input"
                       tid="unitNumberInput"
                       maxlength="100"
                       placeholder="(optional)"
                       [(ngModel)]="formValues.unit"
                       [disabled]="!selectProperty && prefillAddressForm">
            </div>
            <div class="Field HOA-card-flex-child-100 HOA-card-flex-offset-child-left">
                <label for="address2" class="Field-label" tid="address2Label">
                    Address Line 2
                    <div style="float: right;"></div>
                </label>
                <input type="text"
                       name="address2"
                       id="address2"
                       class="Input"
                       tid="address2Input"
                       maxlength="100"
                       placeholder="(optional)"
                       #address2="ngModel"
                       [ngClass]="{'HOA-form-input-field-error': formErrors.noPoBox2}"
                       (blur)="onBlur(address2)"
                       [(ngModel)]="formValues.address2"
                       [disabled]="!selectProperty && prefillAddressForm">
                <div *ngIf="formErrors.noPoBox2">
                    <span class="HOA-form-field-error" tid="address1-field-error">PO Box addresses are not allowed.</span>
                </div>
            </div>
        </div>
        <div class="HOA-card-flex-container">
            <div class="Field HOA-card-flex-offset-child-left">
                <label for="city" class="Field-label" tid="cityLabel">
                    City
                    <span class="asterisk-required">&nbsp;*</span>
                    <div style="float: right;">
                        <span class="HOAPass__ReactFieldInput--loader" style="opacity: 0;"></span>
                    </div>
                </label>
                <input type="text"
                       name="city"
                       id="city"
                       required
                       class="Input"
                       tid="cityInput"
                       maxlength="100"
                       #city="ngModel"
                       (blur)="onBlur(city)"
                       [ngClass]="{'HOA-form-input-field-error': formErrors.city}"
                       [(ngModel)]="formValues.city"
                       [disabled]="!selectProperty && prefillAddressForm">
                <div *ngIf="formErrors.city">
                    <span class="HOA-form-field-error" tid="city-field-error">Please enter a city.</span>
                </div>
            </div>
            <div class="HOA-card-sub-flex-container">
                <div *ngIf="countryRequiresState" class="Field HOA-card-flex-offset-child-right HOA-card-pR1">
                    <label for="state" class="Field-label" tid="stateLabel">
                        {{stateLabel}}
                        <span class="asterisk-required">&nbsp;*</span>
                        <div style="float: right;"></div>
                    </label>
                    <div class="Select Select--State">
                        <select name="state"
                                id="state"
                                required
                                tid="stateSelect"
                                #state="ngModel"
                                (blur)="onBlur(state)"
                                [ngClass]="{'HOA-form-select-field-error': formErrors.state}"
                                [(ngModel)]="formValues.state"
                                [disabled]="!selectProperty && prefillAddressForm">
                            <option [ngValue]=""></option>
                            <option *ngFor="let state of countryStates"  [ngValue]="state.code">{{state.code}}</option>
                        </select>
                        <span class="Select-arrow"></span>
                    </div>
                    <div *ngIf="formErrors.state">
                                <span class="HOA-form-field-error" tid="state-field-error">
                                    {{stateErrorMsg}}
                                </span>
                    </div>
                </div>
                <div *ngIf="countryRequiresPostalCode" class="Field HOA-card-flex-offset-child-right HOA-card-pL1">
                    <label for="zipCode" class="Field-label" tid="zipCodeLabel">
                        {{zipCodeLabel}}
                        <span class="asterisk-required">&nbsp;*</span>
                        <div style="float: right;"></div>
                    </label>
                    <input type="text"
                           name="zipCode"
                           id="zipCode"
                           required
                           class="Input"
                           tid="zipCodeInput"
                           maxlength="12"
                           (input)="zipCodeChange(\$event)"
                           [ngClass]="{'HOA-form-input-field-error': formErrors.zipCode}"
                           [(ngModel)]="formValues.zipCode"
                           [disabled]="!selectProperty && prefillAddressForm">
                    <div *ngIf="formErrors.zipCode">
                                <span class="HOA-form-field-error" tid="zipCode-field-error">
                                    {{zipErrorMessage}}
                                </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="HOA-card-flex-container">
            <div class="Field HOA-card-flex-offset-child-left">
                <label for="country" class="Field-label" tid="countryLabel">
                    Country<span class="asterisk-required">&nbsp;*</span>
                    <div style="float: right;"></div>
                </label>
                <div class="Select Select--State">
                    <select name="country"
                            id="country"
                            required
                            tid="countrySelect"
                            #country="ngModel"
                            (ngModelChange)="onCountryChange(country)"
                            [(ngModel)]="formValues.country"
                            [disabled]="!selectProperty && prefillAddressForm">
                        <option *ngFor="let country of cardPaymentCountries"
                                [ngValue]="country.code">{{country.code}} - {{country.name}}</option>
                    </select>
                    <span class="Select-arrow"></span>
                </div>
            </div>
        </div>
    </div>
</form>`;
// Exports
module.exports = code;